import getFormData from './getFormData';
import calculatePrice from './calculatePrice';
import maybeDefault from './maybeDefault';
import formattedPrice from './formattedPrice';

const Utils = { getFormData, calculatePrice, maybeDefault, formattedPrice };

export default Utils;
